import {
  ApplicationRef,
  Injectable,
  NgZone,
  TemplateRef
} from '@angular/core';
import {
  Overlay,
  OverlayRef,
  OverlayPositionBuilder
} from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { ViewContainerRef } from '@angular/core';
import {filter, fromEvent, Subscription} from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class DropdownToggleService {
  private dropdownsVisibility: Record<string, boolean> = {}; // Tracks visibility of dropdowns
  private outsideClickSub?: Subscription;

  constructor(
    private overlay: Overlay,
    private positionBuilder: OverlayPositionBuilder,
    private appRef: ApplicationRef,
    private zone: NgZone
  ) {}

  isDropdownVisible(id: string): boolean {
    return this.dropdownsVisibility[id];
  }

  // Hide all dropdowns
  hideAllDropdowns(): void {
    this.dropdownsVisibility = {};
  }

toggleDropdown(id: string) {
    this.dropdownsVisibility[id] = !this.dropdownsVisibility[id];
  }

  closeAll() {
    Object.keys(this.dropdownsVisibility).forEach(
      (key) => (this.dropdownsVisibility[key] = false)
    );
  }

  // matDropdown

  private overlayRef: OverlayRef | null = null;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
  openDropdown(template: TemplateRef<any>,
    viewContainerRef: ViewContainerRef,
    options: {
      top?: number;
      right?: number;
    } = {}
  ) {
    this.closeDropdown();

    const positionStrategy = this.overlay
      .position()
      .global()
      .top(`${options.top ?? 60}px`)
      .right(`${options.right ?? 22}px`);

    this.overlayRef = this.overlay.create({
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.reposition(),
      hasBackdrop: false, // No backdrop
    });

    const portal = new TemplatePortal(template, viewContainerRef);
    this.overlayRef.attach(portal);

    
    this.setupOutsideClickListener();
  }
private setupOutsideClickListener(): void {
  this.zone.runOutsideAngular(() => {
    setTimeout(() => this.initializeOutsideClickSubscription());
  });
}

private initializeOutsideClickSubscription(): void {
  this.outsideClickSub = fromEvent<MouseEvent>(document, 'click')
    .pipe(filter((event) => this.isOutsideOverlay(event)))
    .subscribe(() => this.zone.run(() => this.closeDropdown()));
}

private isOutsideOverlay(event: MouseEvent): boolean {
  const overlayEl = this.overlayRef?.overlayElement;
  return overlayEl != null && !overlayEl.contains(event.target as Node);
}
  closeDropdown() {
    this.outsideClickSub?.unsubscribe();
    this.overlayRef?.dispose();
    this.overlayRef = undefined;
  }
}
